import { ColourItem } from 'approot/shared/colour/colour-token.style';
import {
  ComponentOuterStyle,
  COMPONENT_COLOURS,
} from './component-settings-borders.constants';

export function isBorderApplied(
  style: ComponentOuterStyle | null | undefined
): boolean {
  return !!style?.outerBorder;
}

export function isBackgroundApplied(
  style: ComponentOuterStyle | null | undefined
): boolean {
  return !!style?.outerBackgroundColour;
}

export function getAppliedColour(
  style: ComponentOuterStyle | null | undefined
): ColourItem | undefined {
  return COMPONENT_COLOURS.find(c => c.base === style?.outerBaseColour);
}
